module.exports = __webpack_public_path__ + "static/media/alien.f650c5f0.png";